// Reference: https://www.youtube.com/watch?v=yAI9fbbH-rM
// https://apexcharts.com/react-chart-demos/column-charts/stacked-columns-100/

import { useEffect, useState } from 'react'
import Chart from 'react-apexcharts'
import { useTheme } from '../../../../contexts/ThemeContext'

const COLORS = ['#F89C74', '#66C5CC', '#8BE0A4', '#DCB0F2', '#F6CF71']

const ApexLineChart = ({ data, title, height }) => {
  const { theme } = useTheme()
  const [chartData, setChartData] = useState(null)

  useEffect(() => {
    const labelColor = theme === 'dark' ? '#d1d5db' : '#6b7280'
    buildChart(labelColor)
  }, [data, theme])

  const buildChart = (labelColor) => {
    setChartData({
      series: data || [],
      options: {
        chart: {
          fontFamily: 'DM Sans, sans-serif',
          toolbar: { show: false },
          zoom: { enabled: false },
        },

        colors: COLORS, 
        stroke: {
          curve: 'smooth',
          width: 3,
          colors: COLORS,
        },

        markers: {
          size: 5,
          strokeWidth: 2,
          strokeColors: '#ffffff',
          colors: COLORS, 
          hover: { size: 7 },
        },

        legend: {
          show: true,
          position: 'bottom',
          fontSize: '14px',
          fontFamily: 'Inter',
          labels: {
            colors: labelColor,
            useSeriesColors: true,
          },
        },

        dataLabels: {
          enabled: true,
          formatter: (val) =>
            val > 0 ? Math.round(val).toLocaleString() : '',
          style: {
            fontSize: '11px',
            fontWeight: 600,
          },
        },

        xaxis: {
          categories: [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
          ],
          title: {
            text: 'Months',
            style: {
              color: labelColor,
              fontSize: '12px',
              fontWeight: 500,
            },
          },
          labels: {
            style: { colors: labelColor },
          },
        },

        yaxis: {
          title: {
            text: 'Tonnes of CO₂e',
            style: {
              color: labelColor,
              fontSize: '14px',
              fontWeight: 500,
            },
          },
          labels: {
            style: { colors: labelColor },
            formatter: (val) => Math.round(val),
          },
        },

        tooltip: {
          y: {
            formatter: (val) =>
              `${val.toLocaleString()} tCO₂e`,
          },
        },

        grid: {
          borderColor:
            theme === 'dark' ? '#374151' : '#e5e7eb',
          strokeDashArray: 4,
        },
      },
    })
  }

  return (
    <div className="px-2 py-2">
      <h3 className="text-left px-6 font-semibold">{title}</h3>

      {chartData && (
        <Chart
          options={chartData.options}
          series={chartData.series}
          type="line"
          height={height}
        />
      )}
    </div>
  )
}

export default ApexLineChart
